function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 0.166748C2.78 0.166748 0.166664 2.78008 0.166664 6.00008C0.166664 9.22008 2.78 11.8334 6 11.8334C9.22 11.8334 11.8333 9.22008 11.8333 6.00008C11.8333 2.78008 9.22 0.166748 6 0.166748ZM6 8.91675C5.67916 8.91675 5.41666 8.65425 5.41666 8.33342V6.00008C5.41666 5.67925 5.67916 5.41675 6 5.41675C6.32083 5.41675 6.58333 5.67925 6.58333 6.00008V8.33342C6.58333 8.65425 6.32083 8.91675 6 8.91675ZM6 4.25008C5.67916 4.25008 5.41666 3.98758 5.41666 3.66675C5.41666 3.34591 5.67916 3.08342 6 3.08342C6.32083 3.08342 6.58333 3.34591 6.58333 3.66675C6.58333 3.98758 6.32083 4.25008 6 4.25008Z",
  fill: "#547EBD"
});
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.04ace759f72669dc0a899e7afdc7c76e.svg";
export { ForwardRef as ReactComponent };